import React, { Fragment } from 'react';
import moment from 'moment';
import cn from 'classnames';
import DayTaskWrapper from './DayTaskWrapper';
import Cells from './Cells';
import { generateDayTasks, getGridColumn, sortDayTasks } from '../utils';
import { cellHeight } from '../../../constants/common';
import { states } from '../../../constants/states';
import useCellClickHandlers from '../../../hooks/useCellClickHandlers';
import useMoreButtonClick from '../../../hooks/useMoreButtonClick';
import Task from '../../Task/Task';
import commonStyles from '../../../Calendar.module.scss';
import { containerIds } from '../../../constants/containerIds';
import CellWithMoreBtn from './CellWithMoreBtn';
import styles from '../CalendarGrid.module.scss';
import { views } from '../../../constants/views';
import { modes } from '../../../constants/modes';
import { useCalendarState } from '../../../context/CalendarContext';

const WeekView = ({ rowCount }) => {
  const { calendarSheet, calendarData, state, localTask, view, mode, showOwner } =
    useCalendarState();

  const { handleWeekCellClick } = useCellClickHandlers();

  const handleMoreButtonClick = useMoreButtonClick();

  const heightTask = showOwner && mode === modes.calendar && view === views.day;

  return (
    <>
      <div
        id={containerIds.daylongTasksWeek}
        className={styles.daylongContainer}
        style={{
          gridColumn: '2/-1',
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          top: '152px',
        }}
      >
        {calendarData.map((item, dataIndex) => {
          const daylongTasks = item.daylongTasks?.filter((task) => task.visible);

          return (
            <CellWithMoreBtn
              key={dataIndex}
              className={cn(styles.cellWrapper, {
                [styles.borderRight]: dataIndex !== 6,
              })}
              style={{
                gridColumn: `${dataIndex + 1}/${dataIndex + 2}`,
              }}
              taskCount={daylongTasks?.length}
              onMoreBtnClick={() => handleMoreButtonClick(item)}
            >
              {daylongTasks?.slice(0, 6).map((task) => {
                return (
                  <Task
                    key={task.id}
                    id={task.id}
                    infoDirection={daylongTasks.length > 2 ? 'column' : 'row'}
                    hideWorkers={daylongTasks.length > 2}
                    hideTimeInterval={daylongTasks.length > 2}
                    inline={daylongTasks.length > 2}
                    task={task}
                    rootClassName={cn(
                      commonStyles[`checkbox-${task.index}`],
                      'task'
                    )}
                    style={{ maxHeight: '56px', maxWidth: '336px' }}
                    getPopupContainer={() =>
                      document.getElementById(containerIds.daylongTasksWeek)
                    }
                  />
                );
              })}
            </CellWithMoreBtn>
          );
        })}
      </div>
      {calendarData.map((item, dataIndex) => {
        const taskArray =
          localTask && item.day.isSame(moment(localTask.fromDate), 'day')
            ? item.tasks.concat(localTask)
            : item.tasks;

        const { tasks } = generateDayTasks(taskArray);

        return (
          <div
            key={dataIndex}
            className={cn(styles.weekColumn, styles.weekColumnPrint, {
              [styles.borderRight]: dataIndex !== 6,
            })}
            style={{ gridColumn: getGridColumn(dataIndex) }}
          >
            <Cells
              rowCount={rowCount}
              style={{ height: `${cellHeight(heightTask, calendarData)}px` }}
              onClick={
                state === states.addTask
                  ? (_e, index) => handleWeekCellClick(index, dataIndex)
                  : undefined
              }
            />
            <div className={styles.weekTasksContainer}>
              {tasks.map((tasksArr) => {
                return tasksArr.sort(sortDayTasks).map((task, taskIndex) => (
                  <DayTaskWrapper
                    key={task.id || task.requestId}
                    day={calendarSheet
                      .clone()
                      .startOf('week')
                      .day(dataIndex + 1)}
                    task={task}
                    taskIndex={taskIndex}
                    taskCount={tasksArr.length}
                  />
                ));
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default WeekView;
